import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import Content from "../components/ContentHeader.js";
import Route from "../components/Route.js";
import ScrollTop from "./ScrollTop";
import Slogan from "./Slogan";
import { getCaseBookDetail } from "../api/CasebookApi.js";

// CSS
import "../css/CasePage.css";

function CasebookDetail() {
  const { id } = useParams();
  const [item, setItem] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getCaseBookDetail(id);
        setItem(result);
      } catch (error) {
        console.error("API 실패:", error);
      }
    };

    fetchData();
  }, [id]);

  if (!item) {
    return <div>로딩 중입니다...</div>;
  }

  return (
    <div className="casebook_page">
      <ScrollTop />

      <Helmet>
        <title>레인보우브레인 | 지능형자동화 전문기업</title>
        <meta
          name="description"
          content="우리 회사에도 적용할 수 있을까? 실제 도입 사례로 확인해보세요."
        />
      </Helmet>

      <Content
        title="CASEBOOK"
        title1={
          <p className="content-title1">
            생성형 AI 도입 사례가 궁금하다면?
            <br />
            지금 사례집 신청하고, 실제 RAG 적용법을 확인해보세요.
          </p>
        }
      />

      <Route route1="MEDIA" route2="CASEBOOK" />

      <div className="content_bg">
        <div className="container">
          <div className="casebook_wrap">
            <div className="casebook_left">
              <div className="left_img">
                <img src={item.img} alt="메인배경" />
              </div>
              <div
                className="contents2"
                dangerouslySetInnerHTML={{ __html: item.content }}
              />
            </div>
            <iframe
              src={item.link}
              frameBorder="0"
              marginHeight="0"
              marginWidth="0"
              title="Google Form"
            />
          </div>
        </div>
      </div>

      <Slogan containerPadding="5vw 0" />
    </div>
  );
}

export default CasebookDetail;
